import React from 'react';
import react_logo from '../assets/img/tg_logo/react.png';
import react_native_logo from '../assets/img/tg_logo/react_native.png';
import php_logo from '../assets/img/tg_logo/php.png';
import laravel_logo from '../assets/img/tg_logo/laravel.png';
import javascript_logo from '../assets/img/tg_logo/javascript.png';
import inertia_logo from '../assets/img/tg_logo/inertia.png';
import sql_logo from '../assets/img/tg_logo/sql.png';
import mysql_logo from '../assets/img/tg_logo/mysql.png';
import bootstrap_logo from '../assets/img/tg_logo/bootstrap.png';
import tailwind_logo from '../assets/img/tg_logo/tailwind.png';
import html_logo from '../assets/img/tg_logo/html.png';
import css_logo from '../assets/img/tg_logo/css.png';

const Technology = () => {
    const items = [
        {title: 'React', link: 'https://reactjs.org', image: react_logo},
        {title: 'React Native', link: 'https://reactnative.dev', image: react_native_logo},
        {title: 'PHP', link: 'https://www.php.net', image: php_logo},
        {title: 'Laravel', link: 'https://laravel.com', image: laravel_logo},
        {title: 'Javascript', link: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript', image: javascript_logo},
        {title: 'Inertia Js', link: 'https://inertiajs.com', image: inertia_logo},
        {title: 'SQL', link: 'https://docs.oracle.com/cd/E12151_01/index.htm', image: sql_logo},
        {title: 'MySQL', link: 'https://dev.mysql.com', image: mysql_logo},
        {title: 'Bootstrap', link: 'https://getbootstrap.com', image: bootstrap_logo},
        {title: 'Tailwind css', link: 'https://tailwindcss.com', image: tailwind_logo},
        {title: 'HTML', link: 'https://devdocs.io/html', image: html_logo},
        {title: 'CSS', link: 'https://devdocs.io/css', image: css_logo},
    ]

    
    return (
        <section className="my-5 py-10 px-2 sm:px-4 md:px-8 lg:px-12 xl:px-14">
            <h2 className="my-2 p-3 bg-white shadow-md text-center text-xl md:text-3xl font-extrabold">Technology</h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 justify-center gap-4 lg:gap-6">
                {items.map((item,index) => (
                    <a key={index} href={item.link} target="_blank" rel="noreferrer" className="bg-white shadow-md hover:shadow-lg animate__animated animate__zoomInUp">
                        <div className="p-2 sm:p-4 md:p-6 lg:p-8">
                            <img src={item.image} alt={item.title} className="mx-auto max-h-24 transition duration-1000 hover:scale-110" />
                        </div>
                        <h2 className="text-center px-2 py-4 text-slate-900 font-bold text-lg md:text-xl">{item.title}</h2>
                    </a>
                ))}

            </div>
        </section>
    )
}

export default Technology